var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 93,
    viewBox: "0 0 149 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.9 21.8C96.3 21.8 94.9 23.1 94.9 24.8C94.9 26.4 96.2 27.8 97.9 27.8C99.5 27.8 100.9 26.5 100.9 24.8C100.8 23.1 99.5 21.8 97.9 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 0C96.3 0 94.9 1.3 94.9 3C94.9 4.6 96.2 6 97.9 6C99.5 6 100.9 4.7 100.9 3C100.8 1.3 99.5 0 97.9 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 21.8C120 21.8 118.6 23.1 118.6 24.8C118.6 26.4 119.9 27.8 121.6 27.8C123.2 27.8 124.6 26.5 124.6 24.8C124.5 23.1 123.2 21.8 121.6 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 0C120 0 118.6 1.3 118.6 3C118.6 4.6 119.9 6 121.6 6C123.2 6 124.6 4.7 124.6 3C124.5 1.3 123.2 0 121.6 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 21.8C143.7 21.8 142.3 23.1 142.3 24.8C142.3 26.4 143.6 27.8 145.3 27.8C146.9 27.8 148.3 26.5 148.3 24.8C148.3 23.1 146.9 21.8 145.3 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 0C143.7 0 142.3 1.3 142.3 3C142.3 4.6 143.6 6 145.3 6C146.9 6 148.3 4.7 148.3 3C148.3 1.3 146.9 0 145.3 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 87C96.3 87 94.9 88.3 94.9 90C94.9 91.6 96.2 93 97.9 93C99.5 93 100.9 91.7 100.9 90C100.8 88.3 99.5 87 97.9 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 65.2C96.3 65.2 94.9 66.5 94.9 68.2C94.9 69.8 96.2 71.2 97.9 71.2C99.5 71.2 100.9 69.9 100.9 68.2C100.8 66.6 99.5 65.2 97.9 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9 43.5C96.3 43.5 94.9 44.8 94.9 46.5C94.9 48.1 96.2 49.5 97.9 49.5C99.5 49.5 100.9 48.2 100.9 46.5C100.8 44.8 99.5 43.5 97.9 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 87C120 87 118.6 88.3 118.6 90C118.6 91.6 119.9 93 121.6 93C123.2 93 124.6 91.7 124.6 90C124.5 88.3 123.2 87 121.6 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 65.2C120 65.2 118.6 66.5 118.6 68.2C118.6 69.8 119.9 71.2 121.6 71.2C123.2 71.2 124.6 69.9 124.6 68.2C124.5 66.6 123.2 65.2 121.6 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 43.5C120 43.5 118.6 44.8 118.6 46.5C118.6 48.1 119.9 49.5 121.6 49.5C123.2 49.5 124.6 48.2 124.6 46.5C124.5 44.8 123.2 43.5 121.6 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 87C143.7 87 142.3 88.3 142.3 90C142.3 91.6 143.6 93 145.3 93C146.9 93 148.3 91.7 148.3 90C148.3 88.3 146.9 87 145.3 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 65.2C143.7 65.2 142.3 66.5 142.3 68.2C142.3 69.8 143.6 71.2 145.3 71.2C146.9 71.2 148.3 69.9 148.3 68.2C148.3 66.6 146.9 65.2 145.3 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.3 43.5C143.7 43.5 142.3 44.8 142.3 46.5C142.3 48.1 143.6 49.5 145.3 49.5C146.9 49.5 148.3 48.2 148.3 46.5C148.3 44.8 146.9 43.5 145.3 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21.8C1.4 21.8 0 23.1 0 24.8C0 26.4 1.3 27.8 3 27.8C4.6 27.8 6 26.5 6 24.8C6 23.1 4.7 21.8 3 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.4 0 0 1.3 0 3C0 4.6 1.3 6 3 6C4.6 6 6 4.7 6 3C6 1.3 4.7 0 3 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 21.8C25.1 21.8 23.7 23.1 23.7 24.8C23.7 26.4 25 27.8 26.7 27.8C28.3 27.8 29.7 26.5 29.7 24.8C29.7 23.1 28.4 21.8 26.7 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 0C25.1 0 23.7 1.3 23.7 3C23.7 4.6 25 6 26.7 6C28.3 6 29.7 4.7 29.7 3C29.7 1.3 28.4 0 26.7 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 21.8C48.8 21.8 47.4 23.1 47.4 24.8C47.4 26.4 48.7 27.8 50.4 27.8C52 27.8 53.4 26.5 53.4 24.8C53.4 23.1 52.1 21.8 50.4 21.8Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 0C48.8 0 47.4 1.3 47.4 3C47.4 4.6 48.7 6 50.4 6C52 6 53.4 4.7 53.4 3C53.4 1.3 52.1 0 50.4 0Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 23.1C76.4 22.8 76.1 22.5 75.8 22.3C75.3 22 74.8 21.8 74.1 21.8C73.7 21.8 73.3 21.9 72.9 22C72.5 22.2 72.2 22.4 72 22.6C71.5 23.1 71.1 23.9 71.1 24.7C71.1 25.5 71.4 26.3 72 26.8C72.3 27.1 72.6 27.3 72.9 27.4C73.3 27.6 73.6 27.6 74.1 27.6C74.7 27.6 75.3 27.4 75.8 27.1C76.1 26.9 76.4 26.6 76.6 26.3C76.8 26 77 25.6 77 25.2C77 25 77.1 24.8 77.1 24.6C77.1 24.4 77.1 24.2 77 24C77 23.7 76.8 23.4 76.6 23.1Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 1.29999C76.4 0.999988 76.1 0.7 75.8 0.5C75.3 0.2 74.8 0 74.1 0C73.7 0 73.3 0.100012 72.9 0.200012C72.5 0.400012 72.2 0.599988 72 0.799988C71.5 1.29999 71.1 2.10002 71.1 2.90002C71.1 3.70002 71.4 4.5 72 5C72.3 5.3 72.6 5.50004 72.9 5.60004C73.3 5.80004 73.6 5.79999 74.1 5.79999C74.7 5.79999 75.3 5.59999 75.8 5.29999C76.1 5.09999 76.4 4.8 76.6 4.5C76.8 4.2 77 3.80002 77 3.40002C77 3.20002 77.1 2.99999 77.1 2.79999C77.1 2.59999 77.1 2.40001 77 2.20001C77 2.00001 76.8 1.59999 76.6 1.29999Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 87C1.4 87 0 88.3 0 90C0 91.6 1.3 93 3 93C4.6 93 6 91.7 6 90C6 88.3 4.7 87 3 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 65.2C1.4 65.2 0 66.5 0 68.2C0 69.8 1.3 71.2 3 71.2C4.6 71.2 6 69.9 6 68.2C6 66.6 4.7 65.2 3 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 43.5C1.4 43.5 0 44.8 0 46.5C0 48.1 1.3 49.5 3 49.5C4.6 49.5 6 48.2 6 46.5C6 44.8 4.7 43.5 3 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 87C25.1 87 23.7 88.3 23.7 90C23.7 91.6 25 93 26.7 93C28.3 93 29.7 91.7 29.7 90C29.7 88.3 28.4 87 26.7 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 65.2C25.1 65.2 23.7 66.5 23.7 68.2C23.7 69.8 25 71.2 26.7 71.2C28.3 71.2 29.7 69.9 29.7 68.2C29.7 66.6 28.4 65.2 26.7 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7 43.5C25.1 43.5 23.7 44.8 23.7 46.5C23.7 48.1 25 49.5 26.7 49.5C28.3 49.5 29.7 48.2 29.7 46.5C29.7 44.8 28.4 43.5 26.7 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 87C48.8 87 47.4 88.3 47.4 90C47.4 91.6 48.7 93 50.4 93C52 93 53.4 91.7 53.4 90C53.4 88.3 52.1 87 50.4 87Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 65.2C48.8 65.2 47.4 66.5 47.4 68.2C47.4 69.8 48.7 71.2 50.4 71.2C52 71.2 53.4 69.9 53.4 68.2C53.4 66.6 52.1 65.2 50.4 65.2Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4 43.5C48.8 43.5 47.4 44.8 47.4 46.5C47.4 48.1 48.7 49.5 50.4 49.5C52 49.5 53.4 48.2 53.4 46.5C53.4 44.8 52.1 43.5 50.4 43.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 88.3C76.4 88 76.1 87.7 75.8 87.5C75.3 87.2 74.8 87 74.1 87C73.7 87 73.3 87.1 72.9 87.2C72.5 87.4 72.2 87.6 72 87.8C71.5 88.3 71.1 89.1 71.1 89.9C71.1 90.7 71.4 91.5 72 92C72.3 92.3 72.6 92.5 72.9 92.6C73.3 92.7 73.6 92.8 74.1 92.8C74.7 92.8 75.3 92.6 75.8 92.3C76.1 92.1 76.4 91.8 76.6 91.5C76.8 91.2 77 90.8 77 90.4C77 90.2 77.1 90 77.1 89.8C77.1 89.6 77.1 89.4 77 89.2C77 88.9 76.8 88.6 76.6 88.3Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 66.5C76.4 66.2 76.1 65.9 75.8 65.7C75.3 65.4 74.8 65.2 74.1 65.2C73.7 65.2 73.3 65.3 72.9 65.4C72.5 65.6 72.2 65.8 72 66C71.5 66.5 71.1 67.3 71.1 68.1C71.1 68.9 71.4 69.7 72 70.2C72.3 70.5 72.6 70.7 72.9 70.8C73.3 70.9 73.6 71 74.1 71C74.7 71 75.3 70.8 75.8 70.5C76.1 70.3 76.4 70 76.6 69.7C76.8 69.4 77 69 77 68.6C77 68.4 77.1 68.2 77.1 68C77.1 67.8 77.1 67.6 77 67.4C77 67.2 76.8 66.8 76.6 66.5Z",
    fill: "#9992FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6 44.8C76.4 44.5 76.1 44.2 75.8 44C75.3 43.7 74.8 43.5 74.1 43.5C73.7 43.5 73.3 43.6 72.9 43.7C72.5 43.8 72.2 44.1 72 44.3C71.5 44.8 71.1 45.6 71.1 46.4C71.1 47.2 71.4 48 72 48.5C72.3 48.8 72.6 49 72.9 49.1C73.3 49.3 73.6 49.3 74.1 49.3C74.7 49.3 75.3 49.1 75.8 48.8C76.1 48.6 76.4 48.3 76.6 48C76.8 47.7 77 47.3 77 46.9C77 46.7 77.1 46.5 77.1 46.3C77.1 46.1 77.1 45.9 77 45.7C77 45.5 76.8 45.1 76.6 44.8Z",
    fill: "#9992FF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsPurple);
export default __webpack_public_path__ + "static/media/dotsPurple.8048c668.svg";
export { ForwardRef as ReactComponent };